import React, { useState, useContext } from 'react';
import apiClient from '../api/client';
import { UserContext } from "./UserContext";
import { useNavigate } from 'react-router-dom';
import './AddOperatorForm.css'; // 🎨 Add your CSS here
import FormHeader from '../FormHeader';
import { toast } from 'react-toastify';

const AddOperatorForm = () => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const [form, setForm] = useState({
    username: "",
    password: "",
    networkName: "",
    operatorName: "",
    phoneNumber: "",
    Email: "",
    address: "",

    operCode: user?.operCode || "",
    watchoOperCode: user?.watchoOperCode || "",

    internetEnabled: user?.internetEnabled || 0,
    internetBaseUrl: user?.internetBaseUrl || "",
    internetToken: user?.internetToken || "",

    railtelEnabled: user?.railtelEnabled || 0,

    pioneeriptvOprId: user?.pioneeriptvOprId || "",
    pioneeriptvToken: user?.pioneeriptvToken || "",

    dvplEnabled: user?.dvplEnabled || 0,
    dvplBaseUrl: user?.dvplBaseUrl || "",
    dvplToken: user?.dvplToken || "",
    dvplPartnerId: user?.dvplPartnerId || "",
    dvplBranchId: user?.dvplBranchId || "",

    role: "operator",
    created_by: user?.id,
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    const updatedForm = {
      ...form,
      [name]: value,
    };

    if (name === 'phoneNumber') {
      updatedForm.username = value;
      updatedForm.password = value;
    }

    setForm(updatedForm);

    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const validate = () => {
    const newErrors = {};
    if (!form.networkName.trim()) newErrors.networkName = "Network name is required";
    if (!form.operatorName.trim()) newErrors.operatorName = "Operator name is required";
    if (!form.phoneNumber.trim()) newErrors.phoneNumber = "Phone number is required";
    if (!/^\d{10}$/.test(form.phoneNumber)) newErrors.phoneNumber = "Phone number must be 10 digits";
    if (!form.Email.trim()) newErrors.Email = "Email is required";
    if (!/\S+@\S+\.\S+/.test(form.Email)) newErrors.Email = "Invalid email format";
    if (!form.address.trim()) newErrors.address = "Address is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) {
      toast.warn("Please Add required fields.");
      return;
    }

    const operatorId = user.operatorId;
    try {
      await apiClient.post('/operator_api.php', {
        ...form,
        created_by: operatorId,
      });

      toast.success('Operator added successfully!');
      navigate('/operators', { replace: true });

    } catch (err) {
      if (err.response && err.response.status === 409) {
        toast.warn('Operator already exists.');
      } else if (err.response && err.response.status === 400) {
        toast.error('Missing required fields.');
      } else {
        toast('Failed to add Operator. Please try again later.');
      }
    }
  };

  return (
    <>
      <FormHeader />

      <div className={`form-container ${Object.keys(errors).length > 0 ? "form-container-error" : ""}`}>
        <h2>Add Operator</h2>
        <label>Network Name</label>
        <input
          name="networkName"
          placeholder="Network Name"
          onChange={handleChange}
          className={errors.networkName ? "error-input" : ""}
        />
        {errors.networkName && <p className="error-text">{errors.networkName}</p>}

        <label>Operator Name</label>
        <input
          name="operatorName"
          placeholder="Name"
          onChange={handleChange}
          className={errors.operatorName ? "error-input" : ""}
        />
        {errors.operatorName && <p className="error-text">{errors.operatorName}</p>}

        <label>Phone Number</label>
        <input
          name="phoneNumber"
          placeholder="Phone"
          onChange={handleChange}
          className={errors.phoneNumber ? "error-input" : ""}
        />
        {errors.phoneNumber && <p className="error-text">{errors.phoneNumber}</p>}

        <label>Email</label>
        <input
          name="Email"
          placeholder="Email"
          onChange={handleChange}
          className={errors.Email ? "error-input" : ""}
        />
        {errors.Email && <p className="error-text">{errors.Email}</p>}

        <label>Address</label>
        <input
          name="address"
          placeholder="Address"
          onChange={handleChange}
          className={errors.address ? "error-input" : ""}
        />
        {errors.address && <p className="error-text">{errors.address}</p>}

        {user?.role === "superadmin" && (
          <>
            <div className="toggle-container">
              <label className="toggle-label">
                <span className="toggle-text">Enable Internet Integration</span>
                <input
                  type="checkbox"
                  checked={form.internetEnabled === 1}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      internetEnabled: e.target.checked ? 1 : 0,
                    })
                  }
                />
                <span className="toggle-switch">
                  <span className="toggle-slider"></span>
                </span>
              </label>
            </div>

            {form.internetEnabled === 1 && (
              <div className="internet-section">
                <div className="internet-fields">
                  <label>Internet Base URL</label>
                  <input
                    name="internetBaseUrl"
                    value={form.internetBaseUrl}
                    onChange={handleChange}
                    placeholder="https://radius.example.com"
                  />

                  <label>Internet Token</label>
                  <input
                    name="internetToken"
                    value={form.internetToken}
                    onChange={handleChange}
                    placeholder="Bearer Token"
                  />
                </div>
              </div>
            )}

            <div className="toggle-container">
              <label className="toggle-label">
                <span className="toggle-text">Enable RailTel Integration</span>
                <input
                  type="checkbox"
                  checked={form.railtelEnabled === 1}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      railtelEnabled: e.target.checked ? 1 : 0,
                    })
                  }
                />
                <span className="toggle-switch">
                  <span className="toggle-slider"></span>
                </span>
              </label>
            </div>
            {/* No extra credential fields here — RailTel auth (x-api-key) is
                one shared platform-level secret held by the backend, not a
                per-operator credential like Internet's base URL/token. */}

            <label>Pioneer IPTV Operator ID</label>
            <input
              name="pioneeriptvOprId"
              value={form.pioneeriptvOprId}
              onChange={handleChange}
              placeholder="Pioneer IPTV Operator ID"
            />
            <label>Pioneer IPTV Token</label>
            <input
              name="pioneeriptvToken"
              value={form.pioneeriptvToken}
              onChange={handleChange}
              placeholder="Pioneer IPTV Token"
            />

            <div className="toggle-container">
            <label className="toggle-label">
              <span className="toggle-text">Enable DVPL Integration</span>
              <input
                type="checkbox"
                checked={form.dvplEnabled === 1}
                onChange={(e) =>
                  setForm(prev => ({
                    ...prev,
                    dvplEnabled: e.target.checked ? 1 : 0,
                  }))
                }
              />
              <span className="toggle-switch">
                <span className="toggle-slider"></span>
              </span>
            </label>
          </div>

          {form.dvplEnabled === 1 && (
            <div className="internet-section">
              <div className="internet-fields">
                <label>DVPL Base URL</label>
                <input
                  name="dvplBaseUrl"
                  value={form.dvplBaseUrl}
                  onChange={handleChange}
                  placeholder="https://radius.example.com"
                />

                <label>DVPL Token</label>
                <input
                  name="dvplToken"
                  value={form.dvplToken}
                  onChange={handleChange}
                  placeholder="Bearer Token"
                />

                <label>DVPL Partner ID</label>
                <input
                  name="dvplPartnerId"
                  value={form.dvplPartnerId}
                  onChange={handleChange}
                  placeholder="Partner ID"
                />

                <label>DVPL Branch ID</label>
                <input
                  name="dvplBranchId"
                  value={form.dvplBranchId}
                  onChange={handleChange}
                  placeholder="Branch ID"
                />
              </div>
            </div>
          )}
          </>
        )}

        <div className="add-cancel">
          <button onClick={handleSubmit}>Add Operator</button>
          <button
            className="cancel-btn"
            onClick={() => { navigate('/operators', { replace: true }); }}
          >
            Cancel
          </button>
        </div>
      </div>
    </>
  );
};

export default AddOperatorForm;
